// extracted by mini-css-extract-plugin
export var rateTable = "_5i-0";